<template>
  <div class="container-fluid container-lg bg-gray-100 p-3 mb-5 md:pl-20 md:pr-20">
   <loading
                 color="#fff"
                 backgroundColor="#494343cc"
                 :active="isLoadingFinalPurchase"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="true"
                 z-index="9999"
                />
    <router-link v-if="!buttonsDisabled" type="button" class="hover:underline block text-left" to="/carga-identificacion">
      <svg
        class="h-8 w-8 fill-current text-blue-900"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="274.835 394.86 54.965 55.15"
      >
        <defs />
        <path
          d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
        />
      </svg>
    </router-link>
    <div
      class="container-fluid pt-10 md:pl-48 md:pr-48 lg:pl-40 xl:pl-40 bg-white rounded-lg p-2 box-shadow text-lightBlack"
    >
      <div class="flex items-center justify-center">
        <p class="text-center text-2xl lg:text-3xl">Resumen de Compra</p>
        <p v-show="!showSummary" v-on:click="toggleShowSummary">
          <mdicon name="chevron-down"/>
        </p>
        <p v-show="showSummary" v-on:click="toggleShowSummary">
         <mdicon name="chevron-right"/>
        </p>
      </div>
      <div v-if="!showSummary" class="pl-5 pr-5">
        <div class="flex text-left sm:text-lg text-lightBlack font-semibold md:mb-2">
          <div class="w-full">
            <p>Plan</p>
          </div>
          <div class="w-full text-right font-bold">
            <p>Suma Asegurada</p>
          </div>
        </div>

        <div
          class="flex items-center text-left md:text-base text-lightBlack"
          v-for="quotes in jsonWithQuotes"
          :key="quotes.product_id"
        >
          <div class="w-full">
            <p class="m-0">{{ quotes.product_name }}</p>
          </div>
          <div class="w-full text-right">
            <p class="m-0">{{ $filters.toCurrency(quotes.benefits[0].sum_assured) }}</p>
          </div>
        </div>
        <div class="mt-4 md:text-base text-left md:mb-5">
          <div class="w-full sm:text-lg font-semibold md:mb-2">
            <p class="m-0">Información Personal</p>
          </div>
          <div class="w-full">
            <label class="mb-2" v-if="personalData != null">
              {{
                (personalData.client.first_name
                  ? personalData.client.first_name
                  : "") +
                " " +
                (personalData.client.second_name
                  ? personalData.client.second_name
                  : "") +
                " " +
                personalData.client.paternal_lastname +
                " " +
                (personalData.client.maternal_lastname
                  ? personalData.client.maternal_lastname
                  : "")
              }}
            </label>
          </div>
          <p class="m-0">{{ personalData.client.date_birth }}</p>
          <p class="m-0">{{ personalData.client.gender == "H" ? "Hombre" : "Mujer" }}</p>
          <p class="m-0">{{ personalData.client.marital_status }}</p>
          <p class="m-0">Colonia: {{ personalData.client.neighborhood }}</p>
          <p class="m-0">Calle: {{ personalData.client.street }}</p>
          <p class="m-0">No. {{ personalData.client.exterior_number }}</p>
          <p class="m-0">Email: {{ personalData.client.emails }}</p>
          <p class="m-0">
            Celular: ({{ personalData.client.lada_cellphone }})
            {{ personalData.client.cellphone_number }}
          </p>
        </div>
        <div class="mt-4" v-if="workplace">
          <div class="w-full text-left sm:text-lg font-semibold md:mb-2">
            <p class="m-0">Información Laboral</p>
          </div>
          <div class="w-full text-left md:text-base">
            <p class="m-0">Estatus: {{ workplace.status }}</p>
            <p class="m-0">Base: {{ workplace.base }}</p>
            <p v-if="workplace.delegation">
              Delegación: {{ workplace.delegation }}
            </p>
          </div>
        </div>
        <div
          class="mt-5 text-gray-500"
          v-if="kinship == 'Titular' && beneficiaryArray != null"
        >
          <p v-if="!showBeneficiary" class="flex mx-auto" v-on:click="toggleShowBeneficiary">
            Ver Beneficiarios <mdicon name="chevron-down"/>
          </p>
          <p v-if="showBeneficiary" class="flex mx-auto" v-on:click="toggleShowBeneficiary">
            Ocultar Beneficiarios <mdicon name="chevron-up"/>
          </p>
        </div>

        <div class="text-left  md:inline-flex lg:inline-flex xl:inline-flex w-full">
          <!-- Beneficiarios-->
          <div
            v-if="showBeneficiary && beneficiaryArray != null"
            class="w-full md:w-2/3 lg:w-2/3 xl:w-2/3"
          >
            <div
              
              v-for="(beneficiary, index) in beneficiaryArray"
              v-bind:index="beneficiaryArray"
              :key="beneficiary.id"
            >
              <div class="w-2/3 lg:w-1/2 md:w-1/2 xl:w-1/2 items-center">
                <div class="">
                  <label class="mb-2">
                    {{
                      beneficiary.first_name +
                      " " +
                      (beneficiary.second_name ? beneficiary.second_name : "") +
                      " " +
                      beneficiary.paternal_lastname +
                      " " +
                      (beneficiary.maternal_lastname
                        ? beneficiary.maternal_lastname
                        : "")
                    }}
                  </label>
                </div>
                <div class="">
                  <label class="mb-2 text-xs text-gray-600">
                    {{ beneficiary.kinship.label }}
                  </label>
                </div>
              </div>

              <div class="lg:w-1/3 inline-flex items-center mt-2">
                <div class="items-center">
                  <label class="mb-2 text-3xl text-gray-500">
                    {{ beneficiary.percentage + "%" }}
                  </label>
                </div>
                <div class="items-center pl-1">
                  <button :disabled="buttonsDisabled"
                    @click="editBeneficiary(index)"
                    class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-2 border border-gray-400 rounded shadow"
                  >
                    <svg
                      class="cursor-pointer text-xl h-3 w-3 fill-current text-gray-600"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <defs />
                      <path
                        d="M4 14a1 1 0 01.3-.7l11-11a1 1 0 011.4 0l3 3a1 1 0 010 1.4l-11 11a1 1 0 01-.7.3H5a1 1 0 01-1-1v-3z"
                        class="primary"
                      />
                      <rect
                        width="20"
                        height="2"
                        x="2"
                        y="20"
                        class="secondary"
                        rx="1"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- Economic Dependents -->
          <div class="mt-2 text-gray-500 mx-2" v-if="kinship != 'Titular'">
            <p v-show="!showEconomicDependent" v-on:click="toggleShowEconomicDependent">
              Ver Dependiente Económico <mdicon name="chevron-up" />
            </p>
            <p v-show="showEconomicDependent" v-on:click="toggleShowEconomicDependent">
              Ocultar Dependiente Económico <mdicon name="chevron-down"/>
            </p>
          </div>
          <div
            v-if="showEconomicDependent && economicDependents != null"
            class="w-full md:w-2/3 lg:w-2/3 xl:w-2/3"
          >
            <div>
              <div class="w-2/3 lg:w-1/2 md:w-1/2 xl:w-1/2 items-center mt-5">
                <div class="">
                  <label class="mt-5 mb-2">
                    {{
                      economicDependents[0].first_name +
                      " " +
                      (economicDependents[0].second_name
                        ? economicDependents[0].second_name
                        : "") +
                      " " +
                      economicDependents[0].paternal_lastname +
                      " " +
                      (economicDependents[0].maternal_lastname
                        ? economicDependents[0].maternal_lastname
                        : "")
                    }}
                  </label>
                </div>
                <div class="">
                  <label class="mt-2 mb-2 text-xs text-gray-600">
                    {{ economicDependents[0].kinship }}
                  </label>
                </div>
                <div class="">
                  <label class="mt-2 mb-2 text-xs text-gray-600">
                    {{ economicDependents[0].date_birth }}
                  </label>
                </div>
                <div class="">
                  <label class="mt-2 mb-2 text-xs text-gray-600">
                    {{
                      economicDependents[0].gender == "H" ? "Hombre" : "Mujer"
                    }}
                  </label>
                </div>
              </div>

              <div class="lg:w-1/3 inline-flex items-center mt-2">
                <div class="items-center pl-1">
                  <button :disabled="buttonsDisabled"
                    @click="editEconomicDependent()"
                    class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-2 border border-gray-400 rounded shadow"
                  >
                    <svg
                      class="cursor-pointer text-xl h-3 w-3 fill-current text-gray-600"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <defs />
                      <path
                        d="M4 14a1 1 0 01.3-.7l11-11a1 1 0 011.4 0l3 3a1 1 0 010 1.4l-11 11a1 1 0 01-.7.3H5a1 1 0 01-1-1v-3z"
                        class="primary"
                      />
                      <rect
                        width="20"
                        height="2"
                        x="2"
                        y="20"
                        class="secondary"
                        rx="1"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-col md:w-3/3 text-right pr-5">
        <div class="mb-2">
          <p class="m-0">__________________</p>
        </div>
        <div class="inline-flex items-center text-right">
          <div class="w-full">
            <p>Total Quincenal:</p>
          </div>
          <div class="ml-2 text-3xl">
            <p>{{$filters.toCurrency(total) }}</p>
          </div>
        </div>
      </div>





        <div class="text-gray-500 inline-block mx-auto">
          <p class="flex" v-if="!showAuthorizedDiscount" v-on:click="toggleShowAuthorizedDiscount">
            Ver Autorizo de descuento <mdicon name="chevron-up" />
          </p>
          <p class="flex" v-if="showAuthorizedDiscount" v-on:click="toggleShowAuthorizedDiscount">
            Ocultar Autorizo de descuento <mdicon name="chevron-down"/>
          </p>
        </div>

        <div class="mt-2 mx-5">
          <p class="text-sm md:text-xl text-justify md:leading-relaxed" v-show="showAuthorizedDiscount">
            Por este conducto autorizo que la cantidad
            {{ $filters.toCurrency(total) }} sea descontada de mis sueldo durante
            XX pagos o hasta cubrir la totalidad de mis seguros. Para cualquier
            aclaración o reclamo se utilizarán los comprobantes de sueldo (talón
            de cheque) los cuales presentaré en el momento requerido. Así mismo
            estoy de acuerdo en que sí por cualquier circunstancia no se me
            descuenta la cantidad pactada, ésta sea aplicada en las quincenas
            subsecuentes. Acepto que se proceda a la cancelación de los
            beneficios adquiridos si, por cualquier motivo, no se me puede
            aplicar descuento o no realizo los pagos correspondientes por 3
            quincenas consecutivas o bien si por descuentos incompletos acumulo
            un adeudo por un momento equivalente a 3 quincenas de aportación, y
            no regularizo esta situación en las oficinas de Línea Magisterial.
            Hago constar que estoy enterado(a) y de acuerdo con cada uno de los
            puntos anteriores por lo que firmo de conformidad en uso de los
            facultades mentales. <br />
            Los valores autorizados en este documento son fijos por el periodo
            de un año a partir de la fecha de contratación de los seguros y
            autorizo las variaciones a la alza o a la baja para las
            correspondientes renovaciones automáticas , que podrán ser con la
            compañía de seguros autorizada o con otra compañía de seguros que no
            afecte las coberturas contratadas, Autorizo se verifique la liquidez
            a través del talón de cheque o de medios electrónicos. Si el
            asegurado desea no continuar con la protección debe acudir a las
            oficinas de Línea Magisterial para trámite de cancelación o
            solicitarlo a través de nuestros promotores. Las aportaciones para
            maestros con licencia se harán directamente en las oficinas de Línea
            Magisterial.
          </p>
        </div>
        <div class="text-center mt-10 mb-5 px-10 items-center">
          <span>He leído y acepto las condiciones del </span
          ><a
            class="text-goodGreen"
            href=""
            v-on:click.prevent="redirectTo('https://www.lineamagisterial.com/aviso.php')"
            >Aviso de Privacidad</a
          >
        </div>
        <div class="text-center mb-5">
          <button 
            id="button_yes"
            :disabled="buttonsDisabled"
            :class="[
              'hover:bg-darkGray text-xl py-1 px-20 m-2 rounded-full',
              acceptConditions ? 'bg-lightGray' : 'activeClass',
            ]"
            v-on:click="
              (notice_of_privacy_type =
                'plan_costos_v200501_recibi_reglamento_si'),
                (acceptConditions = true)
            "
          >
            Sí
          </button>
          <button 
            id="button_no"
            :disabled="buttonsDisabled"
            v-bind:class="[
              'hover:bg-darkGray text-xl py-1 px-20 m-2 rounded-full',
              acceptConditions ? 'activeClass' : 'bg-lightGray',
            ]"
            v-on:click="
              (notice_of_privacy_type =
                'plan_costos_v200501_recibi_reglamento_no'),
                (acceptConditions = false)
            "
          >
            No
          </button>
        </div>


        <div class="text-center px-5 mb-5" v-if="acceptConditions == false">
          <span class="text-red-600 text-xl font-semibold"
            >Debes aceptar las condiciones del Aviso de Privacidad para
            continuar</span
          >
        </div>


      <div  class="w-full p-2 flex justify-center text-center mt-5 mb-2" v-if="!showSignAndSend && acceptConditions">
        <button
          v-if="!isLoadingFinalPurchase"
          :disabled="buttonsDisabled"
          @click="goTo"
          class="w-full flex justify-center items-center md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-6 rounded"
        >
          <p class="flex items-center m-0">
            Continuar con la compra 
            <mdicon name="chevron-right" />
          </p>
        </button>
      </div>
      <!-- <div class="w-full p-2 text-center mb-2">
                <button class="w-full md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-4 px-6 rounded">
                  Comprar y agregar adicional <md-icon>arrow_forward_ios</md-icon>
                </button>
            </div> -->
    </div>
    <div
      v-if="showSignAndSend"
      class="container-fluid mt-5 pt-10 md:pl-48 md:pr-48 lg:pl-40 xl:pl-40 bg-white rounded-lg box-shadow text-lightBlack flex flex-wrap text-center"
    >
      <div class="w-full">
        <p class="font-semibold mb-5">
          Proceso para verificación de identidad y firma
        </p>
      </div>

      <div class="w-full">
        <button
          @click="goToSign"
          class="mb-5 flex items-center justify-center mx-auto w-full md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-6 rounded"
        >
          <loading
                 :height="15"
                 color="#fff"
                 class="static"
                 :active="isLoading"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="false"
                />
          <p v-if="!isLoading" class="flex items-center justify-center m-0">Iniciar<mdicon name="chevron-right" /></p>
        </button>
      </div>
      <div class="w-full">
        <button
          :disabled="isLoadingEmail"
          @click="sendEmail"
          class="w-full flex items-center justify-center mx-auto md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-xl text-white font-bold py-2 px-6 rounded"
        >
          <loading
                 :height="15"
                 color="#fff"
                 class="static"
                 :active="isLoadingEmail"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="false"
                />
          <p v-if="!isLoadingEmail" class="flex items-center m-0">
            Enviar correo para verificación y firma <mdicon name="chevron-right" />
          </p>
        </button>
      </div>
    </div>
     
  </div>
  
</template>

<script>

import Swal from "sweetalert2";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
  name: "Resume",
  components: { Loading}, 
  data() {
    return {
      buttonsDisabled: false,
      notice_of_privacy_type: "",
      acceptConditions: false,
      personalData: {},
      jsonWithQuotes: null,
      beneficiaryArray: null,
      economicDependents: null,
      workplace: null,
      showSummary: false,
      showBeneficiary: false,
      showEconomicDependent: false,
      showAuthorizedDiscount: true,
      finalPolicy: null,
      kinship: "",
      isLoading: false,
      isLoadingEmail: false,
      isLoadingFinalPurchase: false,
      email: "",
      name: "",
      phone: "",
      showSignAndSend: false,
      url: null,
      apiCabsaCore: process.env.VUE_APP_APICABSACORE,
      ccapi: process.env.VUE_APP_CCAPI,
      api_lineamagisterial: process.env.VUE_APP_APILINEAMAGISTERIAL,
      api_lineamagisterialproducts:
        process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
    };
  },
  created() {
    this.personalData = JSON.parse(localStorage.getItem("policy"));
    console.log("personalData ", this.personalData);
    if (this.personalData) {
      this.kinship = localStorage.kinship;
      this.economicDependents = this.personalData.client.additionals_assured;
      this.workplace = this.personalData.client.workplace;
    } else {
      Swal.fire(
        "Error",
        "Se presentó un error, no fue posible cargar los datos. Favor de contactar a sistemas.",
        "error"
      );
      this.$router.push({ name: "home" });
    }
  },
  mounted() {
    localStorage.removeItem("contractAP");
    this.jsonWithQuotes = JSON.parse(localStorage.getItem("jsonWithQuotes"));
    this.beneficiaryArray = JSON.parse(
      localStorage.getItem("beneficiaryArray")
    );
  },
  unmounted(){
    this.isLoadingFinalPurchase = false;
  },
  methods: {
    onSubmit() {},
    toggleShowBeneficiary() {
      this.showBeneficiary = !this.showBeneficiary;
    },
    toggleShowEconomicDependent() {
      this.showEconomicDependent = !this.showEconomicDependent;
    },
    toggleShowAuthorizedDiscount() {
      this.showAuthorizedDiscount = !this.showAuthorizedDiscount;
    },
    toggleShowSummary() {
      this.showSummary = !this.showSummary;
    },
    editBeneficiary(index) {
      localStorage.setItem("editBeneficiaryArrayIndex", index);
      localStorage.setItem(
        "editBeneficiaryArray",
        JSON.stringify(this.beneficiaryArray)
      );
      this.$router.push({ name: "add-ap-beneficiary" });
    },
    editEconomicDependent() {
      this.$router.push({ name: "economic-dependent" });
    },
    goTo() {
      this.buttonsDisabled = true;
      this.isLoading = true;
      this.isLoadingFinalPurchase = true;
      this.finalPolicy = JSON.parse(localStorage.getItem("policy"));
      var sectionDescription = localStorage.getItem("sectionDescription");
     console.log("sectionDescription", sectionDescription)
      if (this.finalPolicy != null && this.finalPolicy != undefined) {
        let policy = {
          policy_request: this.finalPolicy,
          business: "LM",
          document_type: "solicitud_AP",
          section: sectionDescription == "Queretaro" ? "Seccion 24" : sectionDescription,
        };
        axios
          .post(
            this.api_lineamagisterialproducts + "policy_request/create",
            policy
          )
          .then((response) => {
            this.url = response.data.result.url;
            Swal.fire({
              icon: "success",
              title: "Registro exitoso",
              html: "<p>Su compra se realizó con éxito</p>",
              confirmButtonText: "<button id='button_ok'>OK</button>",
            }
              
            );
            //this.$router.push({ name: "home" });
            localStorage.clear();
            this.$router.push({ name: "home" });
            this.showSignAndSend = true;
            this.showSummary = true;
            //localStorage.clear();
          })
          .catch((error) => {
            this.buttonsDisabled = false;
            this.isLoadingFinalPurchase = false;

            if (error.response.data.errors_list.includes("No se encontro folio disponible")) {
              Swal.fire(
                "Folios insuficientes",
                "Favor de contactar a sistemas para la generación de más folios.",
                "error"
              );
            } else {
              Swal.fire(
                "Error",
                "Se presentó un error, favor de contactar a sistemas.",
                "error"
              );
            }
            console.log("Se presentó un error al crear la póliza: ", error);
          })
          .finally(() => {
            this.isLoading = false;
            this.buttonsDisabled = false;
            
          });
      } else {
        this.buttonsDisabled = false;
        Swal.fire(
          "Error",
          "Se presentó un error, no se ha encontrado la poliza. Favor de contactar a sistemas.",
          "error"
        );
      }
     
    },
    goToSign() {
      //this.$router.push({ name: "digital-signature" });
      window.location.href = this.url;
    },
    async sendEmail() {
      this.isLoadingEmail = true;
      var emailToSendFirst = "";
      var emailToSendSecond = "";
      this.email = this.personalData.client.emails;
      if (this.email != "" && this.email_associate == "") {
        emailToSendFirst = this.email;
      }
      if (this.email == "" && this.email_associate != "") {
        emailToSendFirst = this.email_associate;
      }
      if (this.email != "" && this.email_associate != "") {
        emailToSendFirst = this.email;
        emailToSendSecond = this.email_associate;
      }
      let emails = [];
      emails.push(emailToSendFirst);
      if (
        emailToSendSecond != "" &&
        emailToSendSecond != null &&
        emailToSendSecond != undefined
      ) {
        emails.push(emailToSendSecond);
      }
      let message = this.encriptarMensaje();
      axios
        .post(this.ccapi+"/send_mail", {
          business: "linea magisterial",
          mail: {
            business: "linea magisterial",
            process_type: "documentacion de ap",
            title: "Firma Digital AP",
            body_mail: message,
            mailing_list: emails,
            attachment_list: [],
          },
        })
        .then(() => {
          Swal.fire(
            "Correo enviado.",
            "El envió del correo se realizó correctamente.",
            "success"
          );
          this.email = "";
        })
        .catch(() => {
          Swal.fire(
            "Error",
            "Se presentó un error, favor de contactar a sistemas.",
            "error"
          );
        })
        .finally(() => (this.isLoadingEmail = false));
    },
    encriptarMensaje() {
      const header = { alg: "HS256", typ: "JWT" };
      const encodedHeader = Buffer.from(JSON.stringify(header)).toString(
        "base64"
      );
      var name =
        this.personalData.client.first_name +
        " " +
        this.personalData.client.second_name +
        " " +
        this.personalData.client.paternal_lastname +
        " " +
        this.personalData.client.maternal_lastname;
      var cel =
        this.personalData.client.lada_cellphone +
        this.personalData.client.cellphone_number;
      var data = {
        html:
          "<h2>Información del interesado</h2>" +
          "<b>Nombre:</b> " +
          name +
          "<br><b>Correo:</b> " +
          this.personalData.client.emails +
          "<br><b>Celular:</b> " +
          cel +
          "<br><br>" +
          "<b>Enlace para finalizar la compra:</b> <br>" +
          "<a href=" +
          this.url +
          " target='_blank'>" +
          this.url +
          "<br><br></a> " +
          "<img src=" +
          this.api_lineamagisterial +
          '"/images/logo-horizontal.png" ' +
          'alt="Logo" width="137" heght="160" style="display:block; font-family:Arial; color:#000000; ' +
          'font-size:14px;" border="0" />',
      };
      const encodedPayload = Buffer.from(JSON.stringify(data)).toString(
        "base64"
      );
      var jwtSecret = process.env.VUE_APP_CCAPI_JWT_SECRET_SEND_EMAIL;
      const crypto = require("crypto");
      const signature = crypto
        .createHmac("sha256", jwtSecret)
        .update(encodedHeader + "." + encodedPayload)
        .digest("base64");
      return encodedHeader + "." + encodedPayload + "." + signature;
    },
    redirectTo(url) {
      window.open(url);
    }
  },
  computed: {
    total() {
      return JSON.parse(localStorage.getItem("jsonWithQuotes")).reduce(
        function (total, item) {
          return total + item.cost;
        },
        0
      );
    },
  },
};
</script>

<style scoped>
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>